__turbopack_context__.v({
  "Label": "Label-module-scss-module__jHUxiG__Label",
  "Required": "Label-module-scss-module__jHUxiG__Required",
});
